import React from 'react';
import skills from '../consts/skills';
import techs from '../consts/techs';

const SkillBlock = ({ title, category }) => {
  const skillList = skills[category] || [];
  
  return (
    <div className="skill-block">
      <div className="skill-block__name">{title}</div>
      <ul className="skill-block__list">
        {skillList.map(skill => (
          <li key={skill} className="skill-block__skill">
            {techs[skill] || skill}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SkillBlock;
